<template>
    <div class="financeApplication__form">
        <ValidationProvider name="residential status"
                            :rules="validationRules"
                            v-slot="{ validate }"
                            slim
        >
            <div :class="classNames">
                <FinanceApplicationRadio v-for="option in options"
                                         :name="option.name"
                                         :radio-value="option.value"
                                         :label="option.label"
                                         :id="option.id"
                                         :key="option.id"
                                         v-model="address.status"
                                         @input="onInput($event, validate)"
                />
            </div>
        </ValidationProvider>
    </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import FinanceApplicationRadio from './FinanceApplicationRadio.vue'
export default {
    components: {
        ValidationProvider,
        FinanceApplicationRadio
    },
    props: {
        initialValues: {
            type: Object,
            default: () => {}
        },
        windowWidth: {
            type: Number
        }
    },
    data() {
        return {
            address: this.initialValues.address
        }
    },
    methods: {
        async onInput(value, validate) {
            this.$emit('change-address', {
                key: this.initialValues.index,
                value: this.address
            })

            const { valid } =  await validate(value)
            this.$emit('validate', { key: `addressStatus${this.initialValues.index}`, valid })
        },
    },
    computed: {
        radioId() {
            return 'homeStatus'
        },
        options() {
            const name = 'homeStatus'

            return [
                {
                    name,
                    label: 'Homeowner',
                    value: 'Homeowner',
                    id: this.radioId + 'Homeowner'
                },
                {
                    name,
                    label: 'Joint Owner',
                    value: 'Joint owner',
                    id: this.radioId + 'JointOwner'
                },
                {
                    name,
                    label: 'Tenant - Private',
                    value: 'Tenant - Private',
                    id: this.radioId + 'TenantPrivate'
                },
                // {
                //     name,
                //     label: 'Tenant – Private (unfurnished)',
                //     value: 'Tenant – Private (unfurnished)',
                //     id: this.radioId + 'TenantPrivateUnfurnished'
                // },
                {
                    name,
                    label: 'Tenant - Housing Association',
                    value: 'Tenant - Housing Association',
                    id: this.radioId + 'TenantHousingAssociation'
                },
                {
                    name,
                    label: 'Tenant - Council',
                    value: 'Tenant - Council',
                    id: this.radioId + 'TenantCouncil'
                },
                {
                    name,
                    label: 'Living With Family',
                    value: 'Living With Family',
                    id: this.radioId + 'LivingWithFamily'
                },
                {
                    name,
                    label: 'Military Accommodation',
                    value: 'Military Accommodation',
                    id: this.radioId + 'MilitaryAccommodation'
                },
                {
                    name,
                    label: 'Work Accommodation',
                    value: 'Work Accommodation',
                    id: this.radioId + 'WorkAccommodation'
                },
                {
                    name,
                    label: 'Student Accommodation',
                    value: 'Student Accommodation',
                    id: this.radioId + 'StudentAccommodation'
                },
                {
                    name,
                    label: 'Other',
                    value: 'Other',
                    id: this.radioId + 'Other'
                },
            ]
        },
        classNames() {
            const className = 'financeApplication__form__fields'

            if (this.windowWidth > 920) {
                return `${className} ${className}--threeWide`
            }

            if (this.windowWidth > 530) {
                return `${className} ${className}--twoWide`
            }

            return `${className} ${className}--oneWide`
        },
        validationRules() {
            return {
                required: true,
                included: this.options.map((o) => o.value)
            }
        }
    },
}
</script>